import { ListItem, ListItemIcon, ListItemText, Typography, Menu, MenuItem } from '@material-ui/core';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import { useStyles } from '../styles/components/Nav.styles';
import MobileMenuButton from './MobileMenuButton';
import { useCallback, useState, useContext } from 'react';
import { observer } from 'mobx-react-lite';
import Cookies from 'js-cookie';
import { StoreContext } from '../store';

import config from '../config';

const LANGUAGES = [
  { locale: 'en', label: 'English', flag: '/flags/us.svg' },
  { locale: 'id', label: 'Bahasa Indonesia', flag: '/flags/id.svg' },
];

const LanguageSwitcher = observer(({ open, isMobile }) => {
  const classes = useStyles();
  const router = useRouter();
  const store = useContext(StoreContext);
  const { t } = useTranslation('common');
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = useCallback((event) => {
    if (event) event.preventDefault();
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const changeLanguage = useCallback(async (locale) => {
    handleClose();
    Cookies.set('NEXT_LOCALE', locale, { expires: 365 });

    if (store.organization.selected) {
      store.organization.selected.locale = locale;
      await store.organization.update(store.organization.selected);
    }

    const { pathname, asPath, query } = router;
    router.push({ pathname, query }, asPath, { locale });
  }, [router, handleClose, store.organization.selected]);

  const currentLang = LANGUAGES.find(l => l.locale === router.locale) || LANGUAGES[0];

  return (
    <>
      {isMobile ? (
        <MobileMenuButton
          labelId={currentLang.label}
          Icon={() => <img src={`${config.BASE_PATH}${currentLang.flag}`} alt={currentLang.label} width={24} height={16} />}
          onClick={(item, event) => handleClick(event)}
        />
      ) : (
        <ListItem
          button
          onClick={handleClick}
          className={`${classes.item} ${classes.languageSwitcher}`}
        >
          <ListItemIcon className={classes.item} style={{ minWidth: 56 }}>
            <img src={`${config.BASE_PATH}${currentLang.flag}`} alt={currentLang.label} width={24} height={16} />
          </ListItemIcon>
          <ListItemText
            className={`${classes.itemText} ${open ? classes.itemTextOpen : classes.itemTextClose}`}
            primary={
              <Typography className={classes.item} noWrap>
                {currentLang.label}
              </Typography>
            }
          />
        </ListItem>
      )}

      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        {LANGUAGES.map((lang) => (
          <MenuItem
            key={lang.locale}
            selected={router.locale === lang.locale}
            onClick={() => changeLanguage(lang.locale)}
          >
            <img src={`${config.BASE_PATH}${lang.flag}`} alt={lang.label} width={24} height={16} style={{ marginRight: 10 }} />
            {lang.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
});

export default LanguageSwitcher;
